import gql from 'graphql-tag';

export default
gql `mutation deleteUser($input: DeleteUserInput!){
		deleteUser(input:$input){
			id
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/mutations/DeleteUserMutation.js